import pro1 from '../assets/project1.png';
import pro2 from '../assets/project2.png';
import pro3 from '../assets/project3.png';
import pro4 from '../assets/project4.png';


const ProjectCardData = [
    {
        imgsrc: pro1,
        title: 'My Portfolio',
        text: "Built a portfolio app using MERN Stack, is a dynamic platform for presenting my work, experience, skills, sharing personal information like contact, address, email, about and highlighting your accomplishments. It serves as a perpetual showcase for projects and case studies, offering an effective means of self-expression and establishing your professional identity.",
        view: 'https://my-portfolio-md-arwaz.web.app/',
        source: 'https://github.com/mdarwaz0786/my-portfolio',
    },

    {
        imgsrc: pro2,
        title: 'E-Shop',
        text: "Built an e-commerce web app using MERN Stack, that facilitates online buying and selling of physical goods, services, and digital products, replacing traditional brick-and-mortar transactions. It serves as a digital platform through which businesses efficiently process customer orders, providing a seamless and convenient shopping experience on the internet.",
        view: 'https://e-shop-mdarwaz.web.app/',
        source: 'https://github.com/mdarwaz0786/e-shop',
    },

    {
        imgsrc: pro3,
        title: 'w3school Clone',
        text: 'Built w3School clone using MERN Stack, is a prominent online education platform known for its free web development tutorials. Its standout feature is the "Try it Yourself" with code editor, enabling users to practice coding within each tutorial. This interactive approach fosters hands-on learning, making it a favored choice for web development, Mobile development enthusiasts.',
        view: 'https://w3school-clone-md-arwaz.web.app/',
        source: 'https://github.com/mdarwaz0786/w3school',
    },

    {
        imgsrc: pro4,
        title: 'Weather App',
        text: "Built weather Android app using React Native, is a user-friendly mobile application that provides real-time meteorological information, forecasts, and weather-related data. Users can access accurate weather updates, including temperature, precipitation, and forecasts, making it an essential tool for planning outdoor activities and staying informed about local or global weather conditions",
        view: 'https://expo.dev/accounts/mdarwaz0786/projects/Weather-App/builds/c8f66f9f-c316-41eb-8582-d0ecfcc920d6',
        source: 'https://github.com/mdarwaz0786/weather-app',
    },
];

export default ProjectCardData;